import { Brightness4, Brightness7 } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import React from 'react';
import useSettings from '../../hooks/useSettings';

export default function ThemeToggleButton({ color }) {
    const { themeMode, onChangeMode } = useSettings();

    return (
        <IconButton
            sx={{ mr: 1 }}
            color={color || 'inherit'}
            onClick={() => {
                const isLight = themeMode == 'light';
                const mode = {
                    target: {
                        value: isLight ? 'dark' : 'light',
                    },
                };
                onChangeMode(mode);
            }}
        >
            {themeMode == 'light' ? <Brightness4 /> : <Brightness7 />}
        </IconButton>
    );
}
